import { Select, SelectProps } from '@chakra-ui/react'
import React from 'react'

const SelectInput = (props: SelectProps) => {
  return <Select {...props}></Select>
}

export { SelectInput }
